import React from 'react';
import { CalendarPlus } from 'phosphor-react';
import { CalendarEventInput, addToCalendar } from '@/utils/calendarExport';
import { isNativeWebView, triggerNativeAddToCalendar } from '@/utils/nativeBridge';
import './AddToCalendarButton.css';

interface AddToCalendarButtonProps {
  event: CalendarEventInput;
  /** icon-only (for tight spaces like the booking card actions row) or a full text button */
  variant?: 'icon' | 'text';
  label?: string;
  className?: string;
}

export const AddToCalendarButton: React.FC<AddToCalendarButtonProps> = ({
  event,
  variant = 'text',
  label = 'Add to Calendar',
  className = '',
}) => {
  const handleClick = () => {
    // Inside the wrapped app, hand the raw event data to native over the
    // bridge — never a blob:/data: URL, which native's Linking.openURL can
    // never resolve since it only exists in the WebView's JS context.
    // Outside the wrapper (desktop/browser testing) fall back to the
    // web-only .ics/Google Calendar approach.
    if (isNativeWebView()) {
      triggerNativeAddToCalendar(event);
    } else {
      addToCalendar(event);
    }
  };

  return (
    <button
      type="button"
      className={`atc-trigger atc-trigger--${variant} ${className}`}
      onClick={handleClick}
      aria-label={label}
    >
      <CalendarPlus size={variant === 'icon' ? 18 : 15} weight="bold" />
      {variant === 'text' && <span>{label}</span>}
    </button>
  );
};

export default AddToCalendarButton;
